export const COE = 'client-onboarding';
export const HGT = 'heatmap-generation';
export const BUILD_A_STUDY = 'build-a-study';
export const ACCESS_MANAGEMENT = 'access-management';
export const PIPELINE_TRACKER = 'pipeline-tracker';
export const LEGAL_AGREEMENTS = 'legal-agreements';
